// NavButton.jsx
const NavButton = ({ label, color }) => {
  const isActive = color === label.toLowerCase();

  return (
    <button
      style={{
        color: isActive ? "transparent" : "black",
        background: isActive ? "linear-gradient(90deg, #ffea00, red)" : "none",
        WebkitBackgroundClip: isActive ? "text" : "none",
        backgroundClip: isActive ? "text" : "none",
        cursor: isActive ? "default" : "pointer",
        border: "none",
        backgroundColor: "transparent",
        fontSize: "16px",
        padding: "8px 16px",
        fontWeight: "500",
        fontFamily: "Neue Machina",
      }}
      disabled={isActive}
    >
      {label}
    </button>
  );
};

export default NavButton;
